import React from "react";
import { ILoginResultContext } from "../../types";

export const LoginResultContext = React.createContext({
  authRedirectErrorMessage: undefined,
} as ILoginResultContext);
